export { RatingFacet } from './RatingFacet';
